<template>
  <div class="status-bar">
    <span class="status-bar__week">Week {{ week }}/{{ weeksTotal }}</span>

    <div class="status-bar__right">
      <StarCounter
        :count="stars"
        tone="dark"
        :icon-size="24"
        :filled="false"
        :animate="animateStars"
        :pending="pendingStars"
        @celebrated="$emit('celebrated')"
      />
      <span v-if="showAction" class="status-bar__divider" aria-hidden="true" />
      <button
        v-if="showAction"
        class="status-bar__action"
        :class="{ 'is-disabled': actionDisabled }"
        type="button"
        :disabled="actionDisabled"
        @click="$emit('action')"
      >
        {{ actionLabel }}
      </button>
    </div>
  </div>
</template>

<script setup>
import StarCounter from '@/components/ui/StarCounter.vue'

defineProps({
  week: { type: Number, default: 1 },
  weeksTotal: { type: Number, default: 7 },
  stars: { type: Number, default: 0 },
  showAction: { type: Boolean, default: true },
  actionLabel: { type: String, default: 'Inwisselen' },
  actionDisabled: { type: Boolean, default: false },
  // count earned stars up one by one (+1 chips + a beat) instead of jumping
  animateStars: { type: Boolean, default: false },
  // stars earned while this bar was off screen, e.g. during a minigame
  pendingStars: { type: Number, default: 0 },
})
defineEmits(['action', 'celebrated'])
</script>

<style lang="scss" scoped>
.status-bar {
  // the counter's "+1" chips hang below the bar, so it has to sit above the
  // screen behind it
  position: relative;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--sp-3);
  padding: var(--sp-3) var(--sp-5);
  background: var(--c-white);
}

.status-bar__week {
  padding: 6px 12px;
  font-size: var(--fs-md);
  font-weight: var(--fw-bold);
  color: var(--c-black);
  border: 1px solid var(--c-border);
  border-radius: var(--r-pill);
}

.status-bar__right {
  display: flex;
  align-items: center;
  gap: var(--sp-3);
}

.status-bar__divider {
  width: 1px;
  height: 20px;
  background: var(--c-border);
}

.status-bar__action {
  padding: 7px 14px;
  font-family: var(--font-alt);
  font-weight: var(--fw-semibold);
  font-size: var(--fs-base);
  color: var(--c-white);
  background: var(--c-blue-deep);
  border: none;
  border-radius: var(--r-badge);

  &.is-disabled {
    color: #868686;
    background: #cdcdcd;
  }
}
</style>
